// extracted by mini-css-extract-plugin
export default {"container":"Oca-z","creativeContainer":"Pca-z","copy":"Qca-z","cta":"Rca-z","disabled":"Sca-z","flipped":"Tca-z","productCard":"Uca-z"};